export default "__VITE_ASSET__CL42Nj63__"